 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app~748942c6": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~748942c6": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + chunkId + "." + ({"Admin~Global~ICT~LiveChat~MMIC~RRG~RiskResources~Staff~UMIA~0ccf61b8":"Admin~Global~ICT~LiveChat~MMIC~RRG~RiskResources~Staff~UMIA~0ccf61b8","Admin~Global~ICT~MMIC~RRG~Staff~UMIA~21833f8f":"Admin~Global~ICT~MMIC~RRG~Staff~UMIA~21833f8f","Admin~ICT~MMIC~RRG~Staff~UMIA~83d7d334":"Admin~ICT~MMIC~RRG~Staff~UMIA~83d7d334","Admin~21833f8f":"Admin~21833f8f","Global~ICT~MMIC~RRG~Staff~UMIA~31ecd969":"Global~ICT~MMIC~RRG~Staff~UMIA~31ecd969","ICT~31ecd969":"ICT~31ecd969","MMIC~31ecd969":"MMIC~31ecd969","RRG~31ecd969":"RRG~31ecd969","Staff~31ecd969":"Staff~31ecd969","UMIA~31ecd969":"UMIA~31ecd969","Global~31ecd969":"Global~31ecd969","LiveChat~f71cff67":"LiveChat~f71cff67","RiskResources~21833f8f":"RiskResources~21833f8f","footer~75f0f521":"footer~75f0f521","global-dashboard~21833f8f":"global-dashboard~21833f8f","ict~f71cff67":"ict~f71cff67","Roles~dec40e03":"Roles~dec40e03","UMIAPage~94bb8311":"UMIAPage~94bb8311","RRTemplate~21833f8f":"RRTemplate~21833f8f"}[chunkId]||chunkId) + "-" + {"Admin~Global~ICT~LiveChat~MMIC~RRG~RiskResources~Staff~UMIA~0ccf61b8":"5f9fa21a68daf07bcec2","Admin~Global~ICT~MMIC~RRG~Staff~UMIA~21833f8f":"4b28de7c6323a3f1876f","Admin~ICT~MMIC~RRG~Staff~UMIA~83d7d334":"09abb50a2611b3bdffdb","Admin~21833f8f":"67bca0c2b3c6172012a7","Global~ICT~MMIC~RRG~Staff~UMIA~31ecd969":"1113302128c15f6b95ba","ICT~31ecd969":"1e430b1f1ab48545b333","MMIC~31ecd969":"a753b3d35c2e0c8dc957","RRG~31ecd969":"e328f3620c097d8ddc3d","Staff~31ecd969":"bcdc1494ae39d6925245","UMIA~31ecd969":"81aac35c9b7dd13f0070","Global~31ecd969":"e5f6d223aa9124c8bc6a","LiveChat~f71cff67":"85125d696647b094ce82","RiskResources~21833f8f":"5816a0e164fe22400903","footer~75f0f521":"50bab672849fdbc1e255","global-dashboard~21833f8f":"d65dff9ab1c7577d6b2f","ict~f71cff67":"38e7d9799bca90d881a9","Roles~dec40e03":"1a047c797eb99dbec23b","UMIAPage~94bb8311":"c134f525e6b4bb3fedaf","RRTemplate~21833f8f":"c2da73b8f35f26d6fcfa"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Admin~Global~ICT~MMIC~RRG~Staff~UMIA~21833f8f":1,"Admin~21833f8f":1,"Global~ICT~MMIC~RRG~Staff~UMIA~31ecd969":1,"ICT~31ecd969":1,"MMIC~31ecd969":1,"RRG~31ecd969":1,"Staff~31ecd969":1,"UMIA~31ecd969":1,"Global~31ecd969":1,"LiveChat~f71cff67":1,"RiskResources~21833f8f":1,"global-dashboard~21833f8f":1,"ict~f71cff67":1,"RRTemplate~21833f8f":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Admin~Global~ICT~LiveChat~MMIC~RRG~RiskResources~Staff~UMIA~0ccf61b8":"Admin~Global~ICT~LiveChat~MMIC~RRG~RiskResources~Staff~UMIA~0ccf61b8","Admin~Global~ICT~MMIC~RRG~Staff~UMIA~21833f8f":"Admin~Global~ICT~MMIC~RRG~Staff~UMIA~21833f8f","Admin~ICT~MMIC~RRG~Staff~UMIA~83d7d334":"Admin~ICT~MMIC~RRG~Staff~UMIA~83d7d334","Admin~21833f8f":"Admin~21833f8f","Global~ICT~MMIC~RRG~Staff~UMIA~31ecd969":"Global~ICT~MMIC~RRG~Staff~UMIA~31ecd969","ICT~31ecd969":"ICT~31ecd969","MMIC~31ecd969":"MMIC~31ecd969","RRG~31ecd969":"RRG~31ecd969","Staff~31ecd969":"Staff~31ecd969","UMIA~31ecd969":"UMIA~31ecd969","Global~31ecd969":"Global~31ecd969","LiveChat~f71cff67":"LiveChat~f71cff67","RiskResources~21833f8f":"RiskResources~21833f8f","footer~75f0f521":"footer~75f0f521","global-dashboard~21833f8f":"global-dashboard~21833f8f","ict~f71cff67":"ict~f71cff67","Roles~dec40e03":"Roles~dec40e03","UMIAPage~94bb8311":"UMIAPage~94bb8311","RRTemplate~21833f8f":"RRTemplate~21833f8f"}[chunkId]||chunkId) + "." + {"Admin~Global~ICT~LiveChat~MMIC~RRG~RiskResources~Staff~UMIA~0ccf61b8":"31d6cfe0","Admin~Global~ICT~MMIC~RRG~Staff~UMIA~21833f8f":"60e067fd","Admin~ICT~MMIC~RRG~Staff~UMIA~83d7d334":"31d6cfe0","Admin~21833f8f":"28c6c5fb","Global~ICT~MMIC~RRG~Staff~UMIA~31ecd969":"4f4eb5b7","ICT~31ecd969":"85db160b","MMIC~31ecd969":"a91a25b6","RRG~31ecd969":"609af0ea","Staff~31ecd969":"932f2bb5","UMIA~31ecd969":"6200666f","Global~31ecd969":"2df2f29d","LiveChat~f71cff67":"8656c94d","RiskResources~21833f8f":"076c80c6","footer~75f0f521":"31d6cfe0","global-dashboard~21833f8f":"60c29b45","ict~f71cff67":"f3329ca8","Roles~dec40e03":"31d6cfe0","UMIAPage~94bb8311":"31d6cfe0","RRTemplate~21833f8f":"f6e33b21"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([2,"chunk-vendors~253ae210","chunk-vendors~7274e1de","chunk-vendors~2900d54e"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
